<div class="main-menu">

  <!-- Accordion: tablet (2-col, all open) + mobile (1-col, first open) -->
  <div *ngIf="useAccordion()"
       class="mobile-menu"
       [class.two-col-accordion]="accordionCols() === 2">
    <details *ngFor="let group of visibleGroups; let i = index"
             class="menu-group"
             [attr.open]="accordionCols() === 2 || i === 0 ? '' : null">
      <summary class="group-summary">{{ group.text }}</summary>
      <ul class="no-bullets menu-actions mobile-actions">
        <li *ngFor="let opt of group.children" [hidden]="!hasPermission(opt.textName)">
          <button kendoButton class="menu-btn no-border" (click)="onClick(opt.textName)">
            <img class="btn-img" [src]="opt.imageSrc || 'assets/user.png'" alt="" />
            <span class="option-label">{{ opt.text }}</span>
          </button>
        </li>
      </ul>
    </details>
  </div>

  <!-- Desktop tile layout (>= 1024px) — unchanged -->
  <kendo-tilelayout *ngIf="!useAccordion()"
                    [columns]="3"
                    [rowHeight]="255"
                    [resizable]="true"
                    [reorderable]="true">

    <kendo-tilelayout-item *ngFor="let group of visibleGroups; let i = index"
                           [title]="group.text"
                           [col]="getDynamicCol(i)">
      <kendo-tilelayout-item-body>
        <ul class="no-bullets menu-actions" [ngClass]="getGroupUlClass(group.textName)">
          <li *ngFor="let opt of group.children" [hidden]="!hasPermission(opt.textName)">
            <button kendoButton class="menu-btn no-border" (click)="onClick(opt.textName)">
              <img class="btn-img" [src]="opt.imageSrc || 'assets/user.png'" alt="" />
              <span class="option-label">{{ opt.text }}</span>
            </button>
          </li>
        </ul>
      </kendo-tilelayout-item-body>
    </kendo-tilelayout-item>
  </kendo-tilelayout>

</div>
